// extracted by mini-css-extract-plugin
export default {"confirm":"styles_confirm__kc7Dq","confirm--selected":"styles_confirm--selected__Wdq6R","confirm__action":"styles_confirm__action__sz996"};